<template>
  <h2 class="text-4xl md:text-6xl lg:text-7xl leading-[.9em] font-bold"><slot /></h2>
</template>